"use client"

import { columns } from "./columns"
import { DataGrid, GridPaginationModel } from "@mui/x-data-grid"
import { OrganizationChannel } from "@/interfaces/OrganizationChannel"
import { useRouter, useSearchParams } from "next/navigation"
import { useCallback } from "react"

interface ChannelsDataGridProps {
    data: OrganizationChannel[]
    params: Record<string, string | string[] | undefined>
    totalCount: number
}

export default function ChannelsDataGrid({ data, totalCount, params }: ChannelsDataGridProps) {
    const router = useRouter()
    const searchParams = useSearchParams()

    const onPaginationModelChange = useCallback((model: GridPaginationModel) => {
        const params = new URLSearchParams(searchParams?.toString() || '')
        params.set('page', (model.page + 1).toString())
        params.set('pageSize', model.pageSize.toString())
        router.push(`/channels?${params.toString()}`)
    }, [router, searchParams])

    const paginationModel: GridPaginationModel = {
        page: (parseInt(params.page as string) || 1) - 1,
        pageSize: parseInt(params.pageSize as string) || 10,
    }

    return (
        <>
            <DataGrid
                columns={columns}
                pageSizeOptions={[10, 25, 50, 100]}
                pagination
                paginationModel={paginationModel}
                onPaginationModelChange={onPaginationModelChange}
                rows={data}
                rowCount={totalCount}
                paginationMode="server"
                disableColumnFilter
                disableColumnMenu
                disableColumnSelector
                disableColumnSorting
            />
            <input type="hidden" name="per_page" value={paginationModel.pageSize} />
            <input type="hidden" name="page" value={paginationModel.page} />
        </>
    )
}
